import { Outlet } from 'react-router';
import * as Sentry from '@sentry/react';
import './layout.css';
import SideBar from '../SideBar/SideBar';
import { Layout } from 'antd';
import { ReactNode } from 'react';

const DashboardLayout = ({ children }: { children?: ReactNode | ReactNode[] | undefined }) => {
    const { Content } = Layout;

    return (
        <Layout className="main-layout" hasSider>
            <SideBar />
            <Content>
                <Sentry.ErrorBoundary
                    fallback={
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                paddingTop: '45vh',
                                alignItems: 'center',
                            }}
                        >
                            <h5>Something went wrong</h5>
                            <p>
                                Our team is looking into this issue. Please refresh your browser and
                                try again.
                            </p>
                        </div>
                    }
                >
                    <div className="main-layout-inner w-100">
                        <div className="main-content">
                            {children}
                            <Outlet />
                        </div>
                    </div>
                </Sentry.ErrorBoundary>
            </Content>
        </Layout>
    );
};

export default DashboardLayout;
